import React from 'react';
import {TextFieldReadonly} from "../../common/component/TextFieldReadonly";
import {ClientInfo, ClientRelatedContact} from "./domain";


type Prop = {
    clientProfile?: ClientInfo;
};

export function ClientProfileContactDetail({clientProfile}: Prop) {
    const hasContacts = (clientProfile?.clientRelatedContacts.length ?? 0) > 0;
    return (
        <div className="h-full p-5 bg-white shadow-md flex flex-col scrollbar-always">
            {hasContacts ? clientProfile?.clientRelatedContacts.map((c, idx) => (
                <ContactReadonlyForm key={idx} clientContactDetail={c}
                                     groupLabel={`${c.primaryContact ? 'Primary' : 'Secondary'} Contact`}/>
            )) : (
                <div>No contacts available</div>
            )}
        </div>
    );
}

function useAmericaTelPhoneFormat(phone: string) {
    if (!phone) {
        return '';
    }
    const numberOnlyStr = (phone.match(/(\d+)/g) ?? []).join('');
    const isAmericaTelNum = numberOnlyStr.length === 10;
    if (isAmericaTelNum) {
        return `(${numberOnlyStr.slice(0, 3)}) ${numberOnlyStr.slice(3, 6)}-${numberOnlyStr.slice(6)}`;
    }
    return phone;
}

type ContactReadonlyFormProps = {
    groupLabel: string;
    clientContactDetail: ClientRelatedContact;
}

function ContactReadonlyForm({clientContactDetail, groupLabel}: ContactReadonlyFormProps) {
    return (
        <div className="mb-4 relative w-11/12">
            <div className="absolute ml-4 top-0 bg-white font-semibold">{groupLabel}</div>
            <div className="mt-3 grid grid-cols-2 gap-4 justify-around border-2 w-full p-4">
                <TextFieldReadonly label={"Name"} value={clientContactDetail.name}/>
                <TextFieldReadonly label={"Relationship to Client"}
                                   value={clientContactDetail.relationshipToClient}/>
                <TextFieldReadonly label={"Home Phone"}
                                   value={useAmericaTelPhoneFormat(clientContactDetail.homePhone)}/>
                <TextFieldReadonly label={"Mobile Phone"}
                                   value={useAmericaTelPhoneFormat(clientContactDetail.mobilePhone)}/>
                <TextFieldReadonly label={"Work phone"}
                                   value={useAmericaTelPhoneFormat(clientContactDetail.workPhone)}/>
                <TextFieldReadonly label={"Email"} value={clientContactDetail.email}/>
                <TextFieldReadonly label={"Street"} value={clientContactDetail.street}/>
                <TextFieldReadonly label={"City"} value={clientContactDetail.city}/>
                <TextFieldReadonly label={"State"} value={clientContactDetail.stateCode}/>
                <TextFieldReadonly label={"Zip Code"} value={clientContactDetail.zipCode}/>
            </div>
        </div>
    );
}
